import type { BimContractStatusEnum } from 'gql/graphql';
import { ContractStatusEnum } from 'gql/graphql';
import type { BadgePropStatus } from 'uikit';
import { Badge } from 'uikit';

import * as React from 'react';

export interface IContractStatusListItem {
    id: ContractStatusEnum | BimContractStatusEnum;
    label: string;
}

export const contractStatusCellProps: Record<
    ContractStatusEnum,
    { label: string; status?: BadgePropStatus; className?: string }
> = {
    [ContractStatusEnum.Completed]: { label: 'Завершен', status: 'success' },
    [ContractStatusEnum.Delayed]: { label: 'Отложен', status: 'system' },
    [ContractStatusEnum.InImplementation]: { label: 'На реализации', className: 'in-implementation' },
};

export const getContractStatusLabel = (statusId: ContractStatusEnum | BimContractStatusEnum) =>
    contractStatusCellProps[statusId]?.label ?? 'Не указан';

export const ContractStatus = ({ id }: { id: ContractStatusEnum | BimContractStatusEnum }) => (
    <Badge {...contractStatusCellProps[id]} />
);

export const getContractStatusListItem = (v: ContractStatusEnum | BimContractStatusEnum): IContractStatusListItem => ({
    id: v,
    label: getContractStatusLabel(v),
});

ContractStatus.displayName = 'ContractStatus';
